import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { IonIcon } from 'controls'

import MenuItem from './MenuItem'
import { shouldRenderMenuItem } from './utils'

const MenuGroup = ({
  item,
  index,
  expanded,
  isOpen,
  onToggle,
  token,
  onExpand,
  onItemClick,
}) => {
  const { name, icon, href, isNew, isBeta, children } = item

  const visibleChildren = children.filter(shouldRenderMenuItem)

  if (visibleChildren.length === 0) {
    return null
  }

  const handleParentClick = () => {
    if (!expanded && onExpand) {
      onExpand()
    } else {
      onToggle()
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {href ? (
        <MenuItem item={item} expanded={expanded} token={token} onExpand={onExpand} onItemClick={onItemClick} />
      ) : (
        <div
          className={classnames('parent-menu-item', { collapsed: !expanded })}
          onClick={handleParentClick}
          title={!expanded ? name : undefined}
        >
          <IonIcon
            className="parent-icon"
            size="small"
            icon={icon}
          />
          {expanded && (
            <>
              <span>{name}</span>
              {(isNew || isBeta) && (
                <span
                  className={classnames({
                    'is-new': isNew,
                    'is-beta': isBeta
                  })}
                >
                  <strong>
                    {isNew && 'New'}
                    {isBeta && 'Beta'}
                  </strong>
                </span>
              )}
              <IonIcon
                className="chevron-icon"
                size="small"
                icon={isOpen ? 'ios-arrow-up' : 'ios-arrow-down'}
              />
            </>
          )}
        </div>
      )}
      <div className={classnames('submenu-items', { open: isOpen && expanded })}>
        {visibleChildren.map((child, ix) => (
          <MenuItem
            key={`${index}_${ix}`}
            item={child}
            expanded={expanded}
            padded
            token={token}
            onExpand={onExpand}
            onItemClick={onItemClick}
          />
        ))}
      </div>
    </div>
  )
}

MenuGroup.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string.isRequired,
    icon: PropTypes.string,
    href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isNew: PropTypes.bool,
    isBeta: PropTypes.bool,
    children: PropTypes.array.isRequired
  }).isRequired,
  index: PropTypes.number.isRequired,
  expanded: PropTypes.bool,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  token: PropTypes.string,
  onExpand: PropTypes.func,
  onItemClick: PropTypes.func,
}

MenuGroup.defaultProps = {
  expanded: true,
  isOpen: false,
  token: '',
  onExpand: null,
  onItemClick: () => {},
}

export default MenuGroup
